import('../src/javascripts/attachments-redesign');
import('../src/javascripts/navigation');
